<template>
<v-layout column>
  <h1>Drafts</h1>
    <v-data-table
        :headers="headers"
        :items="drafts"
        :loading="ui.loading"
        :hide-actions="drafts.length <= 10"
        :rows-per-page-items="ui.rowsPerPageItems"
        class="elevation-4 mt-4"
    >
        <v-progress-linear slot="progress" :color="isDark ? 'white' :'blue'" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
            <tr @click="draftDetails(props)" class="pointer" :class="{'grey darken-4 white--text': isDark && (details && details.id === props.item.id), 'primary white--text': !isDark && (details && details.id === props.item.id)}">
            <td>{{ props.item.customer.first_name }} {{ props.item.customer.last_name }}</td>
            <td>{{ props.item.customer.email }}</td>
            <td>{{ calculateItemQuantity(props.item.line_items) }}</td>
            <td>${{ props.item.total_price }}</td>
            <td>{{ props.item.is_shipped_timestamp | toDate }}</td>
            <td>{{ props.item.is_delivered_timestamp | toDate }}</td>
            <td class="text-xs-center">
              <v-icon :class="{'box-card-icon': props.expanded}" v-if="props.item.is_returning">check</v-icon>
            </td>
            </tr>
        </template>

        <template slot="expand" slot-scope="props">
          <v-card v-if="details">

            <v-tabs
            v-model="ui.tab"
            :dark="isDark"
            :light="!isDark"
            fixed-tabs
            grow
            slider-color="transparent"
            >
            <v-tab ripple :style="{'background': isDark && (ui.tab === 1 || ui.tab === 2) ? '#303030!important' : !isDark && (ui.tab === 1 || ui.tab === 2) ? '#E0E0E0!important' : 'transparent'}">
            Details
            </v-tab>
            <v-tab ripple :style="{'background': isDark && (ui.tab === 0 || ui.tab === 2) ? '#303030!important' : !isDark && (ui.tab === 0 || ui.tab === 2) ? '#E0E0E0!important' : 'transparent'}">
            Items
            </v-tab>
            <v-tab ripple :style="{'background': isDark && (ui.tab === 0 || ui.tab === 1) ? '#303030!important' : !isDark && (ui.tab === 0 || ui.tab === 1) ? '#E0E0E0!important' : 'transparent'}">
            Tracking
            </v-tab>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-container grid-list-sm class="ma-0 pa-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm8>
                          <v-layout row wrap>
                            <v-flex xs12 sm6><v-text-field label="First Name" :value="details.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm6><v-text-field label="Last Name" :value="details.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm12><v-text-field label="Email" :value="details.customer.email" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm12><v-text-field label="Address" :value="details.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm12><v-text-field label="Address 2" :value="details.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm4><v-text-field label="City" :value="details.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm4><v-text-field label="State" :value="details.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm4><v-text-field label="Zip" :value="details.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm12><v-text-field label="Country" :value="details.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                            <v-flex xs12 sm12 v-if="details.customer.default_address.phone"><v-text-field label="Phone" :value="details.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Draft ID</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.id}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Account ID</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.customer.id}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="details.subscription_information">
                              <v-list-tile-content>
                                <v-list-tile-title>Box ID</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.subscription_information['Box ID']}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="details.subscription_information">
                              <v-list-tile-content>
                                <v-list-tile-title>Subscription ID</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.subscription_information['Subscription ID']}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="details.subscription_information">
                              <v-list-tile-content>
                                <v-list-tile-title>Subscription Product ID</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.subscription_information['Subscription Product ID']}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="details.subscription_information">
                              <v-list-tile-content>
                                <v-list-tile-title>Subscription Product SKU</v-list-tile-title>
                                <v-list-tile-sub-title>{{details.subscription_information['Subscription Product SKU']}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                            :headers="line_item_headers"
                            :items="details.line_items"
                            :loading="ui.loading"
                            :hide-actions="details.line_items.length <= 10"
                            :rows-per-page-items="ui.rowsPerPageItems"
                            class="elevation-1"
                        >
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                              <tr>
                                <td>{{ props.item.title }}</td>
                                <td>{{ props.item.sku }}</td>
                                <td>{{ (props.item.grams*props.item.quantity) | toOunces}}oz</td>
                                <td>${{ props.item.price }}</td>
                                <td class="text-xs-center">{{ props.item.quantity }}</td>
                              </tr>
                            </template>
                            <template slot="footer">
                              <td style="padding-left:15px;">
                              <strong>Total</strong>
                              </td>
                              <td class="text-xs-right" colspan="80%">
                                <strong>{{calculatedDetailsDraftTotal}}</strong>
                              </td>
                            </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-layout row wrap>
                    <v-flex xs12 sm6>
                    <h3>Shipment</h3><span v-if="!ui.loading && details.draft_shipment_tracking">Tracking Code: {{details.draft_shipment_tracking_code}}<br>Estimated Arrival: {{details.draft_shipment_tracking.est_delivery_date | toTimestamp}}</span>
                    <v-timeline
                      v-if="!ui.loading && details.draft_shipment_tracking"
                      align-top
                      dense              
                    >
                      <v-timeline-item
                        v-for="(detail, i) in details.draft_shipment_tracking.tracking_details"
                        :key="i"
                        small
                        :color="isDark ? 'white' : 'primary'"   
                      >
                        <v-layout pt-3>
                          <v-flex xs3>
                            <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                          </v-flex>
                          <v-flex>
                            <strong>{{detail.message}}</strong>
                            <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>
                    </v-timeline>
                    </v-flex>

                    <v-flex xs12 sm6>
                    <h3>Return Shipment</h3><span v-if="!ui.loading && details.draft_return_tracking">Tracking Code: {{details.draft_return_tracking_code}}<br>Estimated Arrival: {{details.draft_return_tracking.est_delivery_date | toTimestamp}}</span>
                    <v-timeline
                      v-if="!ui.loading && details.draft_return_tracking"
                      align-top
                      dense         
                    >
                      <v-timeline-item
                        v-for="(detail, i) in details.draft_return_tracking.tracking_details"
                        :key="i"
                        small
                        :color="isDark ? 'white' : 'primary'"   
                      >
                        <v-layout pt-3>
                          <v-flex xs3>
                            <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                          </v-flex>
                          <v-flex>
                            <strong>{{detail.message}}</strong>
                            <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>
                    </v-timeline>
                    </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              </v-tabs>
          </v-card>

        </template>
    </v-data-table>
<!--
    <v-dialog v-model="ui.dialog" v-if="details">
      <v-card>
        <v-toolbar tabs>
          <v-toolbar-title>{{details.customer.email}}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tabs slot="extension" v-model="ui.tab" centered grow color="transparent">
            <v-tabs-slider :color="!isDark ? 'primary' : 'grey lighten-5'"></v-tabs-slider>
            <v-tab>Details</v-tab>
            <v-tab>Items</v-tab>
            <v-tab>Tracking</v-tab>
          </v-tabs>
        </v-toolbar>

        <v-tabs-items v-model="ui.tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container grid-list-sm class="ma-0 pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 sm8>
                      <v-layout row wrap>
                        <v-flex xs12 sm6><v-text-field label="First Name" :value="details.customer.first_name" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm6><v-text-field label="Last Name" :value="details.customer.last_name" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field label="Email" :value="details.customer.email" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field label="Address" :value="details.customer.default_address.address1" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field label="Address 2" :value="details.customer.default_address.address2" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm4><v-text-field label="City" :value="details.customer.default_address.city" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm4><v-text-field label="State" :value="details.customer.default_address.province" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm4><v-text-field label="Zip" :value="details.customer.default_address.zip" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12><v-text-field label="Country" :value="details.customer.default_address.country" box readonly hide-details></v-text-field></v-flex>
                        <v-flex xs12 sm12 v-if="details.customer.default_address.phone"><v-text-field label="Phone" :value="details.customer.default_address.phone" box readonly hide-details></v-text-field></v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-list class="pt-0 subscriber-details" style="background:transparent!important;">
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Draft ID</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.id}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>Account ID</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.customer.id}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="details.subscription_information">
                          <v-list-tile-content>
                            <v-list-tile-title>Box ID</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.subscription_information['Box ID']}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="details.subscription_information">
                          <v-list-tile-content>
                            <v-list-tile-title>Subscription ID</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.subscription_information['Subscription ID']}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="details.subscription_information">
                          <v-list-tile-content>
                            <v-list-tile-title>Subscription Product ID</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.subscription_information['Subscription Product ID']}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="details.subscription_information">
                          <v-list-tile-content>
                            <v-list-tile-title>Subscription Product SKU</v-list-tile-title>
                            <v-list-tile-sub-title>{{details.subscription_information['Subscription Product SKU']}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                        :headers="line_item_headers"
                        :items="details.line_items"
                        :loading="ui.loading"
                        :hide-actions="details.line_items.length <= 5"
                        class="elevation-1"
                    >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td>{{ props.item.title }}</td>
                            <td>{{ props.item.sku }}</td>
                            <td>{{ (props.item.grams*props.item.quantity) | toOunces}}oz</td>
                            <td>${{ props.item.price }}</td>
                            <td class="text-xs-center">{{ props.item.quantity }}</td>
                          </tr>
                        </template>
                        <template slot="footer">
                          <td style="padding-left:15px;">
                          Total
                          </td>
                          <td class="text-xs-right" colspan="80%">
                            {{calculatedDetailsDraftTotal}}
                          </td>
                        </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 sm6>
                <h3>Shipment</h3><span v-if="!ui.loading && details.draft_shipment_tracking">Tracking Code: {{details.draft_shipment_tracking_code}}<br>Estimated Arrival: {{details.draft_shipment_tracking.est_delivery_date | toTimestamp}}</span>
                <v-timeline
                  v-if="!ui.loading && details.draft_shipment_tracking"
                  align-top
                  dense                  
                >
                  <v-timeline-item
                    v-for="(detail, i) in details.draft_shipment_tracking.tracking_details"
                    :key="i"
                    small
                  >
                    <v-layout pt-3>
                      <v-flex xs3>
                        <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                      </v-flex>
                      <v-flex>
                        <strong>{{detail.message}}</strong>
                        <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                </v-timeline>
                </v-flex>

                <v-flex xs12 sm6>
                <h3>Return Shipment</h3><span v-if="!ui.loading && details.draft_return_tracking">Tracking Code: {{details.draft_return_tracking_code}}<br>Estimated Arrival: {{details.draft_return_tracking.est_delivery_date | toTimestamp}}</span>
                <v-timeline
                  v-if="!ui.loading && details.draft_return_tracking"
                  align-top
                  dense                  
                >
                  <v-timeline-item
                    v-for="(detail, i) in details.draft_return_tracking.tracking_details"
                    :key="i"
                    small
                  >
                    <v-layout pt-3>
                      <v-flex xs3>
                        <strong>{{detail.datetime | toDate}}<br>{{detail.datetime | toTime}}</strong>
                      </v-flex>
                      <v-flex>
                        <strong>{{detail.message}}</strong>
                        <div class="caption">{{detail.tracking_location.city}} {{detail.tracking_location.state}} {{detail.tracking_location.zip}}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                </v-timeline>
                </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
-->
</v-layout>
</template>

<script>
import { db } from '@/services/firebase.js'
import moment from 'moment'

export default {
  name: 'Drafts',
  data () {
    return {
      ui: {
        loading: true,
        dialog: false,
        tab: null,
        rowsPerPageItems: [25, 50, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }]
      },
      headers: [
          { text: 'Name', align: 'left', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Items', value: 'line_items' },
          { text: 'Worth', value: 'total_price' },
          { text: 'Shipped', value: 'is_shipped_timestamp' },
          { text: 'Delivered', value: 'is_delivered_timestamp' },
          { text: 'Returning?', value: 'is_returning' }
      ],
      line_item_headers: [
        { text: 'Item', align: 'left', value: 'title' },
        { text: 'SKU', value: 'sku' },
        { text: 'Weight', value: 'weight', width: 20 },
        { text: 'Price', value: 'price', width: 20 },
        { text: 'Qty', value: 'quantity', width: 20 }
      ],
      drafts: [],
      details: null
    }
  },
  filters: {
    toDate: function(str){
      if(str === null || str === undefined) return 'N/A'
      return moment(str).format('MM/DD/YY')
    },
    toTime: function(str){
      if(str === null || str === undefined) return 'N/A'
      return moment(str).format('hh:mm:ss A')
    },
    toTimestamp: function(str){
      if(str === null || str === undefined) return 'N/A'
      return moment(str).format('MM/DD/YY hh:mm:ss A')
    },
    toOunces: function(grams) {
      return Math.ceil(grams * 0.0352739619)
    }
  },
  created () {
    var self = this
    db.collection('drafts').onSnapshot(draftsSnapshot => {
        var drafts = []
        draftsSnapshot.forEach(function(doc) {
            drafts.push(doc.data())
        })
        self.drafts = drafts
        self.ui.loading = false
    })
  },
  computed: {
    isAdmin () {
        return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
    },
    isManager () {
        return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
    },
    isDark: function () {
        return this.$vuetify.dark
    },
    calculatedDetailsDraftTotal: function () {
      var self = this
      if(self.details){
        var total = 0
        self.details.line_items.forEach((item) => {
          total = total + (parseFloat(item.price) * item.quantity)
        })
        return '$' + total.toFixed(2)
      } else {
        return '$0.00'
      }
    }
  },
  methods: {
    calculateItemQuantity: function (line_items) {
      var total = 0
      line_items.forEach((item) => {
        total = total + item.quantity
      })
      return total
    },
    draftDetails: function (draft) {
      var self = this
      
      if (!draft.expanded) {

        self.ui.loading = true
        self.details = null
        self.details = draft.item
        self.details.subscription_information = null
        try {
          if(self.details.note){
            var subscription_information = JSON.parse(self.details.note.split('|')[0])
            self.details.subscription_information = subscription_information
          }
        }
        catch (e) {console.error(e)}

        if (self.details.draft_shipment_tracking_code) {
          self.getDraftShipmentTracking(self.details.draft_shipment_tracking_code)
          .then(() => {
            if (self.details.draft_return_tracking_code) {
              self.getDraftReturnTracking(self.details.draft_return_tracking_code)
              .then(() => {
                self.ui.loading = false
                //self.ui.dialog = true
                draft.expanded = !draft.expanded
              })
              .catch((e) => {
                console.error(e)
                self.ui.loading = false
                //self.ui.dialog = true
                draft.expanded = !draft.expanded
              })
            } else {
              self.ui.loading = false
              //self.ui.dialog = true
              draft.expanded = !draft.expanded
            }
          })
          .catch((e) => {
            console.error(e)
            self.ui.loading = false
            //self.ui.dialog = true
            draft.expanded = !draft.expanded
          })
        } else {
          self.ui.loading = false
          //self.ui.dialog = true
          draft.expanded = !draft.expanded
        }
      } else {
        draft.expanded = !draft.expanded
        self.details = null
      }
    },
    getSubscription: function (id) {
      var self = this
      db.collection('subscriptions').doc(id).get()
      .then((doc) => {
        let subscription = doc.data()
        self.details.subscription = subscription
      })
      .catch((err) => {
        console.error(err)
      })
    },
    getDraftShipmentTracking: function (tracking_number) {
      var self = this
      return new Promise((resolve, reject) => {
        db.collection('tracking').doc(tracking_number).get()
        .then((doc) => {
          let tracking = doc.data()
          self.details.draft_shipment_tracking = tracking
          resolve()
        })
        .catch((err) => {
          console.error(err)
          reject()
        })
      })
    },
    getDraftReturnTracking: function (tracking_number) {
      var self = this
      return new Promise((resolve, reject) => {
        db.collection('tracking').doc(tracking_number).get()
        .then((doc) => {
          let tracking = doc.data()
          self.details.draft_return_tracking = tracking
          resolve()
        })
        .catch((err) => {
          console.error(err)
          reject()
        })
      })
    }
  },
  mounted () {

  }
}
</script>

<style lang="stylus" scoped>
.theme--dark-old .v-card
  background #1d2935!important
.theme--dark-old .v-tabs__bar
  background-color #40525B!important
  background #40525B!important
</style>